// File: /src/routes/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
	const { isAuthenticated, loading } = useAuth();

	if (loading) {
		return (
			<div className="loading-text">
				Carregando...
				<br />
				<span className="loading-spinner"></span>
			</div>
		);
	}

	return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
